
	import { Prop, Vue } from 'vue-property-decorator';
	import { Observer } from 'mobx-vue';
	import Component from 'vue-class-component';
	import PrescriptionSummaryCategory from '@/components/new-prescription/prescription-summary/PrescriptionSummaryCategory.vue';
	import PrescriptionSummaryItem from '@/components/new-prescription/prescription-summary/PrescriptionSummaryItem.vue';
	import shellModification from '@/store/prescription/definition/categories/shellModification';
	import postingOptions from '@/store/prescription/definition/categories/postingOptions';
	import topCovers from '@/store/prescription/definition/categories/topCovers';
	import accommodations from '@/store/prescription/definition/categories/accommodations';

	@Observer
	@Component({
		components: {
			PrescriptionSummaryItem,
			PrescriptionSummaryCategory
		}
	})
	export default class PrescriptionSummary extends Vue {
		private shell = shellModification;
		private posting = postingOptions;
		private top = topCovers;
		private accommodations = accommodations;

		@Prop() newPrescription;

		rearfootPostValues() {
			if (this.newPrescription.postingOptions.rearfootPost.override === 'specify') {
				let res: string[] = [];

				if (this.newPrescription.postingOptions.rearfootPost.left?.type && this.newPrescription.postingOptions.rearfootPost.left?.value) {
					res.push(
						`Left ${this.posting.rearfootPost.LR.firstValue[this.newPrescription.postingOptions.rearfootPost.left.type]} ${
							this.posting.rearfootPost.LR.secondValue[this.newPrescription.postingOptions.rearfootPost.left.value]
						} `
					);
				} else {
					res.push('-');
				}

				if (this.newPrescription.postingOptions.rearfootPost.right?.type && this.newPrescription.postingOptions.rearfootPost.right?.value) {
					res.push(
						`Right ${this.posting.rearfootPost.LR.firstValue[this.newPrescription.postingOptions.rearfootPost.right.type]} ${
							this.posting.rearfootPost.LR.secondValue[this.newPrescription.postingOptions.rearfootPost.right.value]
						} `
					);
				} else {
					res.push('-');
				}

				return res;
			} else {
				return this.posting.rearfootPost.selectValues[this.newPrescription.postingOptions.rearfootPost.override];
			}
		}

		forefootPostValues() {
			if (['none', 'balance'].includes(this.newPrescription.postingOptions.forefootPost.override)) {
				return this.posting.forefootPost.selectValues[this.newPrescription.postingOptions.forefootPost.override];
			} else {
				let res: string[] = [];
				res.push(this.posting.forefootPost.selectValues[this.newPrescription.postingOptions.forefootPost.override]);

				if (this.newPrescription.postingOptions.forefootPost.left?.type && this.newPrescription.postingOptions.forefootPost.left?.value) {
					res.push(
						`Left ${this.posting.forefootPost.LR.firstValue[this.newPrescription.postingOptions.forefootPost.left.type]} ${
							this.posting.forefootPost.LR.secondValue[this.newPrescription.postingOptions.forefootPost.left.value]
						} `
					);
				} else {
					res.push('-');
				}

				if (this.newPrescription.postingOptions.forefootPost.right?.type && this.newPrescription.postingOptions.forefootPost.right?.value) {
					res.push(
						`Right ${this.posting.forefootPost.LR.firstValue[this.newPrescription.postingOptions.forefootPost.right.type]} ${
							this.posting.forefootPost.LR.secondValue[this.newPrescription.postingOptions.forefootPost.right.value]
						} `
					);
				} else {
					res.push('-');
				}
				return res;
			}
		}

		extrinsicForefootPostValues() {
			if (this.newPrescription.accommodations.extrinsicForefootPost.override !== 'specify') {
				return this.accommodations.extrinsicForefootPost.selectValues[this.newPrescription.accommodations.extrinsicForefootPost.override];
			} else {
				let res: string[] = [];
				res.push(this.accommodations.extrinsicForefootPost.selectValues[this.newPrescription.accommodations.extrinsicForefootPost.override]);

				if (
					this.newPrescription.accommodations.extrinsicForefootPost.left?.type &&
					this.newPrescription.accommodations.extrinsicForefootPost.left?.value
				) {
					res.push(
						`Left ${this.accommodations.extrinsicForefootPost.LR.firstValue[this.newPrescription.accommodations.extrinsicForefootPost.left.type]} ${
							this.accommodations.extrinsicForefootPost.LR.secondValue[this.newPrescription.accommodations.extrinsicForefootPost.left.value]
						} `
					);
				} else {
					res.push('-');
				}

				if (
					this.newPrescription.accommodations.extrinsicForefootPost.right?.type &&
					this.newPrescription.accommodations.extrinsicForefootPost.right?.value
				) {
					res.push(
						`Right ${
							this.accommodations.extrinsicForefootPost.LR.firstValue[this.newPrescription.accommodations.extrinsicForefootPost.right.type]
						} ${this.accommodations.extrinsicForefootPost.LR.secondValue[this.newPrescription.accommodations.extrinsicForefootPost.right.value]} `
					);
				} else {
					res.push('-');
				}
				return res;
			}
		}

		forefootExtensionValues() {
			if (this.newPrescription.accommodations.forefootExtension.side !== 'none') {
				return [
					this.accommodations.forefootExtension.radioValues[this.newPrescription.accommodations.forefootExtension.side],
					this.accommodations.forefootExtension.selectValues[this.newPrescription.accommodations.forefootExtension.value]
				];
			} else {
				return this.accommodations.forefootExtension.radioValues[this.newPrescription.accommodations.forefootExtension.side];
			}
		}

		mortonsExtensionValues(extension: string) {
			if (this.newPrescription.shellModifications[extension].type !== 'none') {
				return [
					this.shell[extension].radioValues[this.newPrescription.shellModifications[extension].type],
					this.shell[extension].selectValues[this.newPrescription.shellModifications[extension].value],
					this.shell[extension].secondSelectValues[this.newPrescription.shellModifications[extension].side]
				];
			} else {
				return this.shell[extension].radioValues[this.newPrescription.shellModifications[extension].type];
			}
		}

		archReinforcementValues() {
			if (this.newPrescription.shellModifications.archReinforcement.side !== 'none') {
				return [
					this.shell.archReinforcement.radioValues[this.newPrescription.shellModifications.archReinforcement.side],
					this.shell.archReinforcement.selectValues[this.newPrescription.shellModifications.archReinforcement.value],
					this.shell.archReinforcement.secondSelectValues[this.newPrescription.shellModifications.archReinforcement.pattern]
				];
			} else {
				return this.shell.archReinforcement.radioValues[this.newPrescription.shellModifications.archReinforcement.side];
			}
		}

		archModificationsValues() {
			if (
				this.newPrescription.shellModifications.archModification.left === 'none' &&
				this.newPrescription.shellModifications.archModification.right === 'none'
			) {
				return this.shell.archModification.LR[this.newPrescription.shellModifications.archModification.right];
			} else {
				return [
					this.shell.archModification.LR[this.newPrescription.shellModifications.archModification.left],
					this.shell.archModification.LR[this.newPrescription.shellModifications.archModification.right]
				];
			}
		}

		shellRigidity() {
			if (this.newPrescription.shellModifications.shellRigidity == 'super-flex') {
				return [
					this.shell.shellRigidity.radioValues[this.newPrescription.shellModifications.shellRigidity],
					this.shell.shellRigidity.selectValues[this.newPrescription.shellModifications.shellRigidityOption]
				];
			} else {
				return this.shell.shellRigidity.radioValues[this.newPrescription.shellModifications.shellRigidity];
			}
		}
	}
